<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

    <div id="page-administrator-list" class="ag-grid-container">
      <div class="vx-card">
        <grid-panel
            v-if="showGridOne"
            :column-defs="columnDefs"
            class="lg"
            :data="enabledData"
            :loading="loading"
            :search="searchQuery"
            :gridOptions="gridOptions"
            @rowClicked="rowClicked"
            @update:gridApi="(gridApi) => this.gridApi = gridApi"
            title="News"
            autoSize
        >
          <template v-slot:right>
            <button-toggle
                class="mr-4"
                v-model="toggleValue"
                :options="toggle"
            />
          </template>
          <vs-dropdown-item v-if="componentAccess.canCreate.access">
              <span
                  class="flex items-center"
                  @click="$router.push({ name: 'content-management.news.create' })"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Create News</span>
              </span>
            </vs-dropdown-item>
        </grid-panel>

        <grid-panel
            v-else
            :column-defs="columnDefs"
            class="lg"
            :data="disabledData"
            :loading="loading"
            :search="searchQuery"
            :gridOptions="gridOptions"
            @rowClicked="rowClicked"
            @update:gridApi="(gridApi) => this.gridApi = gridApi"
            title="News"
            autoSize
        >
          <template v-slot:right>
            <button-toggle
                class="mr-4"
                v-model="toggleValue"
                :options="toggle"
            />
          </template>

          <vs-dropdown-item v-if="componentAccess.canCreate.access">
              <span
                  class="flex items-center"
                  @click="$router.push({ name: 'content-management.news.create' })"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Create News</span>
              </span>
            </vs-dropdown-item>
        </grid-panel>
      </div>
    </div>
  
  </template>
  
  <script>
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import vSelect from 'vue-select'
  import GridActionBar from "@/views/components/extra-components/GridActionBar";
  import CanAccessMixin from "@/components/mixins/CanAccessMixin";
  import CellRendererVerified from '@/views/components/ag-grid/cell-renderer/CellRendererVerified'
  import CellRendererDate from '@/views/components/ag-grid/cell-renderer/CellRendererDate'
  import { dateFilterParams } from '@/views/components/ag-grid/filter-params/DateComparator';
  import GridPanel from "@/views/components/ag-grid/GridPanel";
  import ButtonToggle from "@/views/components/extra-components/toggle/ButtonToggle";
  
  export default {
    components: {
      vSelect,
      GridPanel,
      GridActionBar,
      CellRendererVerified,
      CellRendererDate,
      ButtonToggle,
    },
    mixins: [CanAccessMixin],
    data () {
      return {
        toggle: [
          {
            text: 'New Articles',
            value: 0,
          },
          {
            text: 'Archived',
            value: 1,
          }
        ],
        toggleValue: 0,
        searchQuery: '',
        showDeleted: false,
        componentAccess: {
          canCreate: {
            route: 'content-management.news.create',
            access: false,
          },
          canEdit: {
            route: 'content-management.news.edit',
            access: false,
          },
        },
        loading: false,
        enabledData: [],
        disabledData: [],
  
        gridApi: null,
        gridOptions: {},
        columnDefs: [
          {
            headerName: 'ID',
            field: 'id',
            filter: 'agTextColumnFilter',
            minWidth: 200,
            width: 200,
            sort: 'asc',
            hide: true,
          },
          {
            headerName: 'Title',
            field: 'NewsTitle',
            filter: 'agTextColumnFilter',
            minWidth: 250,
            maxWidth: 350,
          },
          {
            headerName: 'Message',
            field: 'NewsContent',
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'Applications',
            field: 'application_string',
            filter: 'agTextColumnFilter',
          },
          {
            headerName: 'Valid From',
            field: 'NewsValidFrom',
            filter: 'agDateColumnFilter',
            minWidth: 150,
            maxWidth: 150,
            cellRenderer: "CellRendererDate",
            filterParams: dateFilterParams,
          },
          {
            headerName: 'Valid To',
            field: 'NewsValidTo',
            filter: 'agDateColumnFilter',
            minWidth: 150,
            maxWidth: 150,
            cellRenderer: "CellRendererDate",
            filterParams: dateFilterParams,
          },
          {
            headerName: 'Display For All',
            field: 'IsNewsForAll',
            filter: 'agTextColumnFilter',
            cellRenderer: 'CellRendererVerified',
            cellClass: 'text-center',
            minWidth: 128,
            maxWidth: 128,
          },
        ],
      }
    },
    watch: {
      showDeleted(value) {
        this.list({IsDeleted: value | 0});
      }
    },
    computed: {
      showGridOne() {
        return this.toggleValue === 0;
      },
    },
    methods: {
      modalError(errorMessage) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error occurred',
          text: errorMessage,
          position: 'top-right'
        })
      },
      success(successMessage) {
        this.$vs.notify({
          color: 'success',
          title: 'Contacts updated',
          text: successMessage,
          position: 'top-right'
        })
      },
      rowClicked(data) {
        if (!this.componentAccess.canEdit.access) {
          return;
        }

        this.$root.$router.push({ path: `/content-management/news/${data.data.id}` })
      },
      async list() {
        try {
          let enabledParams = { isEnabled: 1 };
          let disabledParams = { isEnabled: 0 };
          this.loading = true;

          const { data: enabledResponse } = await this.$api.contentManagementNews.all({ params: enabledParams });
          this.enabledData = enabledResponse.data;

          const { data: disabledResponse } = await this.$api.contentManagementNews.all({ params: disabledParams });
          this.disabledData = disabledResponse.data;

          this.gridApi.paginationGoToFirstPage();
        } catch (e) {
          console.log(e);
        } finally {
          this.loading = false;
        }
      },
      loadList () {
        this.list();
      },
    },
    created () {
      this.loadList();
    },
  }
  </script>
  
  <style lang="scss">
  #page-administrator-list {
    .administrator-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
  </style>
  